// "Vistos recentemente": guarda as ultimas maquinas abertas (localStorage)
// pra acesso rapido na paleta Ctrl+K. O operador volta sempre as mesmas
// poucas maquinas — recentes evita re-buscar toda vez.
//
// Guarda apenas o ID + rotulos (leve). A navegacao e reconstruida casando
// o id contra o indice do /park/list ja carregado na paleta — assim nao
// precisamos persistir os objetos pesados de park/appliance.

const KEY = 'cco:recent-machines';
const MAX = 6;

export const getRecentMachines = () => {
  try {
    const raw = window.localStorage.getItem(KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr : [];
  } catch (e) {
    return [];
  }
};

// entry: { id, label, sub }. Dedupe por id, mais recente primeiro, cap MAX.
export const pushRecentMachine = (entry) => {
  if (!entry || entry.id == null || !entry.label) return;
  try {
    const id = String(entry.id);
    const current = getRecentMachines().filter(
      (e) => String(e.id) !== id,
    );
    current.unshift({ id, label: entry.label, sub: entry.sub || '' });
    window.localStorage.setItem(KEY, JSON.stringify(current.slice(0, MAX)));
  } catch (e) {
    // localStorage indisponivel/cheio — recente e best-effort, ignora.
  }
};
